// Money input that displays thousands separators (vi-VN: 4.650.000) while storing
// a raw digit string ("4650000"). Use for all VND amount entry.
import { forwardRef } from "react";
import { Input } from "./input";
import { cn } from "@/lib/utils/cn";

type Props = Omit<
  React.ComponentProps<typeof Input>,
  "value" | "onChange" | "type"
> & {
  value: string;
  onChange: (raw: string) => void;
};

// Group an amount with dots (vi-VN). Accepts a raw digit string from typing
// ("4650000") or a decimal string from the server ("4650000.00"); decimals are
// dropped (VND has no sub-unit).
export function groupVnd(value: string): string {
  const s = String(value ?? "").trim();
  if (s === "") return "";
  const n = Number(s);
  if (isFinite(n)) return new Intl.NumberFormat("vi-VN").format(Math.round(n));
  const digits = s.replace(/[^\d]/g, "");
  return digits === "" ? "" : new Intl.NumberFormat("vi-VN").format(Number(digits));
}

export const MoneyInput = forwardRef<HTMLInputElement, Props>(function MoneyInput(
  { value, onChange, className, ...rest },
  ref,
) {
  return (
    <Input
      ref={ref}
      inputMode="numeric"
      value={groupVnd(value)}
      onChange={(e) => onChange(e.target.value.replace(/[^\d]/g, ""))}
      className={cn("text-right", className)}
      {...rest}
    />
  );
});
